import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { PillarsSection } from '../components/home/PillarsSection';
import { ProductsSection } from '../components/home/ProductsSection';
import { CampaignBanner } from '../components/home/CampaignBanner';
import { CertificationsSection } from '../components/home/CertificationsSection';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { StoresCta } from '../components/home/StoresCta';
export function Home() {
  return <>
      <HeroSection data-id="element-207" data-mp="24hk83ft75nlw" />
      <PillarsSection data-id="element-208" data-mp="24j4swdppls6k" />
      <ProductsSection data-id="element-209" data-mp="29gdbugiom08v" />
      <CampaignBanner data-id="element-210" data-mp="29fvgrn7r9s2j" />
      <CertificationsSection data-id="element-211" data-mp="29ek3mwsf77yr" />
      <TestimonialsSection data-id="element-212" data-mp="29ihq9se7ihne" />
      <StoresCta data-id="element-213" data-mp="2di8bzhovm7l2" />
    </>;
}